import { constants } from '@src/routes/provider/common/constants';
import { getActivityDateRanges } from '../activityDaysToDates';
import { RiskScoreSearchRequest } from '../types';

export function getDefaultRiskScoreSearchRequest(): RiskScoreSearchRequest {
  const { startDate, endDate } = getActivityDateRanges(new Date(), 1);
  const pageSize = constants.DEFAULT_PAGE_SIZE_OPTIONS.slice().reverse()[0];
  return {
    startDate,
    endDate,
    fraudPatternTypeCode: 'ENROLLMENT_FRAUD',
    pageNumber: 0,
    pageSize,
  };
}
